/*! Goldtop - option controls for the slide cart's "You might also like"
    upsells. Every width. Loaded from theme.liquid, because the drawer is on
    every page. Read assets/gt-sheet.js first; this file only decides when to
    open that sheet and what to put in it.

    Joe, 28 Sep: "repeat the same pass on the look of the buttons instead of a
    dropdown and check for any freeze bugs (or optimisations) for the add on pop
    up bar for the 'you may also like' products of the slide cart."

    Joe, 28 Sep, later: "roll out on web ... the button / swatches for the you
    may also like products". The width gate is gone. Nothing else changed: the
    app renders the same upsell markup at 500px as it does at 375px, and the
    sheet sizes itself to the drawer's column - see gt-sheet.js.

    ==================================================================
    THE FREEZE HUNT, AND THE HONEST ANSWER: THERE ISN'T ONE.

    The app's upsell add does not freeze. Driven at 375x812 with the network
    logged: tapping Add on the Leather Tank Bag put the right variant in the
    cart, closed the panel inside a second, left no overlay hit-testing, and
    the drawer was usable at every probe from +300ms to +4.5s. Three of the
    four faults that made our own sheets freeze are simply absent, because the
    app never built them in - there is no double-rAF open without a fallback,
    the panel is removed rather than left at opacity 0, and there is no queued
    open to go stale.

    ONE fault is present, and it is the one that cost three rounds of diagnosis
    on the slide cart sheet. THE APP'S ADD BUTTON IS UNDERNEATH THE BOTTOM
    CHROME. Measured: the panel is anchored to the bottom of the viewport, its
    Add button sits at 758..796 on an 812px screen, and elementFromPoint at the
    middle of that button returns IFRAME#PBarNextFrame, blocker
    DIV#PBarNextFrameWrapper. On screen, enabled, correctly labelled, and not
    tappable.

    Two things have to be said plainly about that. The preview bar only exists
    in theme preview, so a shopper on the live site does not meet that
    particular obstruction - but Joe tests on the preview, so he does. And the
    geometry is the app's, not the bar's: a button whose bottom edge is 16px
    from the bottom of the viewport sits under the home indicator on an iPhone,
    where env(safe-area-inset-bottom) is 34px.

    Our sheet carries clearBottomChrome, so opening it in place of the app's
    panel fixes the measurable case and the one behind it at the same time.

    ==================================================================
    WHY THIS REPLACES THE PANEL RATHER THAN RESTYLING IT.

    The first plan was the house mirror pattern - leave the app's panel in
    place, hide its <select> elements, inject our own rails, and write the
    choice back into the select with a change event, exactly as
    snippets/product-armour.liquid does with Assortion. The mirror itself was
    proved to work: setting the Leather Belt's Colour select to Bourbon and
    dispatching change moved the app's own variant line and rewrote its Add
    button's aria-label, with no help from us.

    THE STYLING IS WHAT KILLED IT. SlideCart HQ ships

        .slidecarthq, .slidecarthq * { ...140 declarations... }

    a total reset on every descendant of the drawer, at specificity (0,1,0),
    loading after the theme. It resets background, border, box-shadow, colour,
    display, font-size, letter-spacing, line-height, margin, padding, position,
    text-transform, transform, width, height and z-index. Every rule in
    gt-slidecart-size.css ties it on specificity and loses on order. Measured
    rather than assumed: a prototype built inside the panel produced chips of
    122x23 with no border at 16px type, and swatches that collapsed to 0x0.
    Re-stating it would mean duplicating the whole control stylesheet at
    #slidecarthq specificity - a second copy to keep in step, which is the
    exact condition this week was spent removing.

    So the sheet opens OUTSIDE the drawer, appended to <body>, where the reset
    cannot reach. One stylesheet, three surfaces.

    The app's own panel is prevented from opening: the tap is caught in the
    CAPTURE phase and stopped before the app's handler sees it. If a future
    version of the app manages to open it anyway, the safety net below closes
    it, so the two can never be on screen together.

    ==================================================================
    WHAT THE DROPDOWNS COST, MEASURED RATHER THAN ASSUMED.

    A correction to the obvious first guess, which was wrong and is worth
    writing down: the app is NOT dishonest about stock. Selecting a sold-out
    value flips its Add button to "Unavailable" and disables it - the same
    model the PDP uses, let the choice land and then tell the truth.

    What a <select> cannot do is say anything IN ADVANCE. Every value looks
    identical until it is chosen, so finding the one colour of four still in
    stock means selecting each in turn and reading the button each time. And
    when it does speak, it collapses "we do not make that" and "that is sold
    out" into the single word "Unavailable" - which is the difference between a
    shopper who tries another size and one who gives up on the product.

    The sheet marks what is gone before the tap, and says which case it is in a
    sentence.

    A caveat on how much that is worth today: of the six upsell products in the
    rail, only the Leather Tank Bag has anything sold out. The marking earns
    its place on the day something goes out of stock, not the day it ships.

    ==================================================================
    ADDING TO CART OURSELVES LOSES NOTHING.

    Checked before it was relied on, because "the app does its own analytics"
    would have been a reasonable objection. A plain /cart/add.js followed by
    SLIDECART_UPDATE() fires the same downstream work as the app's own button:
    Shopify's product_added_to_cart web pixel, the Assortion discount call at
    api.assortion.com/client/discount, the Google ads conversion, and the
    rewards progress bar. They all listen to the cart, not to the app's button.

    afterAdd is "refresh" rather than "open" because the drawer is already on
    screen behind the sheet; re-opening it would be a flicker for nothing.
*/
(function () {
  if (window.__gtScUpsell) return;
  window.__gtScUpsell = true;

  var cache = {};
  var busy = false;

  function q(s, r) { try { return (r || document).querySelector(s); } catch (e) { return null; } }
  function qa(s, r) { try { return [].slice.call((r || document).querySelectorAll(s)); } catch (e) { return []; } }

  function sheet() { return window.GTSheet; }

  function product(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var pr = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { cache[handle] = j; return j; })
      .catch(function () { cache[handle] = null; return null; });
    cache[handle] = pr;
    return pr;
  }

  /* The card carries the product's own link, which is the only place the
     handle appears - data-slidecart-product-id is the numeric product id and
     /products/<id>.js is not a route. */
  function upsellHandle(card) {
    var a = q("a[href*='/products/']", card);
    var href = a ? (a.getAttribute("href") || "") : "";
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  /* The app pre-renders one panel per multi-variant upsell and hides it with
     the inert attribute. If one is open, close it: the sheet and the panel
     must never be on screen together. */
  function shutAppPanel() {
    qa("#slidecarthq .upsell-options").forEach(function (p) {
      if (p.hasAttribute("inert")) return;
      var x = q(".upsell-options-close", p);
      if (x) { try { x.click(); } catch (e) {} }
    });
  }

  function onAdd(card) {
    if (busy) return;
    var s = sheet();
    if (!s) return;                      /* gt-sheet.js absent: let the app have it */
    var handle = upsellHandle(card);
    if (!handle) return;

    busy = true;
    product(handle).then(function (p) {
      busy = false;
      if (!p || !p.variants || !p.variants.length) return;
      s.open({
        product: p,
        confirmLabel: "ADD TO CART",
        /* The drawer is already on screen behind the sheet. */
        afterAdd: "refresh"
      });
      /* Safety net, for the case where a future version of the app opens its
         panel despite the capture-phase stop. */
      setTimeout(shutAppPanel, 120);
      setTimeout(shutAppPanel, 500);
    }).catch(function () { busy = false; });
  }

  /* A single-variant upsell has nothing to choose, so the app's own Add adds it
     directly and there is no panel and no dropdown. Those are left completely
     alone - this file only takes over the ones that would have opened a panel,
     which the app marks with the `multi` class. */
  function isMulti(card) {
    return !!(card && card.classList && card.classList.contains("multi"));
  }

  function start() {
    /* CAPTURE PHASE, so the app's own handler never runs and its panel never
       opens. The app renders in the light DOM and binds at its own root, which
       is below document, so a capture listener here is ahead of it. */
    document.addEventListener("click", function (e) {
      if (!window.GTSheet) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var hit = t.closest("#slidecarthq .upsell-add button, #slidecarthq .upsell-add a");
      if (!hit) return;
      var card = hit.closest(".upsell");
      if (!isMulti(card)) return;        /* one variant: the app's job, untouched */
      e.preventDefault();
      e.stopPropagation();
      onAdd(card);
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
